module.exports = __webpack_public_path__ + "static/media/apartment10.bc71692d.jpg";